import { FC } from "react";
import { IconPropsType } from ".";

export const EmptyUnit: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 6.25H9.75V11.5C9.75 12.1904 9.19036 12.75 8.5 12.75H4.5C3.80964 12.75 3.25 12.1904 3.25 11.5V6.25Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <rect x="4" y="5.5" width="5" height="2" fill="#F8F8F8" />
      <path
        d="M1 5L6.5 1L12 5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
